import http from '../httpService';

const LectureService = {
  getLectureService: params => http.get(`lectures`, { params }),

  registerLectureService: params => http.post('lectures', params),

  updateLectureService: (lectureId, params) => http.patch(`lectures/${lectureId}`, params),

  deleteLectureService: lectureId => http.delete(`lectures/${lectureId}`),
};

export default LectureService;
